<template>
  <div id="event">
    <div>   
    <p></p>
    <p>
      <b style="color:green"
      >This data are provided to you by the CHIME/FRB collaboration. When
        using these data, please cite the <a href="https://arxiv.org/abs/2106.04352" target="_blank"> CHIME/FRB Catalog 1 Paper</a>.</b
      >
      </p>
    <div role="tablist">
      <b-container fluid style="margin-top: 20px">
        <b-row>
          <b-col md="12" class="my-1">
            <b-button
              target="_blank"
              rel="noopener noreferrer"
              href="/analysis"
              block
              variant="outline-info"
              >Click here for Glossary of terms & FITS file information
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="3">
            <b-card
              title= "Old Name"
              tag="article"
              style="max-width: 20rem; background-color: #343A40; color: white"
              class="mb-2"
            >
              <b-card-text>
                <p style="font-size: 150%; color: orange"> {{names[0].previous_name}}</p>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="2">
          </b-col>
          <b-col lg="3">
            <b-card
              title= "TNS Name"
              tag="article"
              style="max-width: 20rem; background-color: #343A40; color: white"
              class="mb-2"
            >
              <b-card-text>
                <p style="font-size: 150%; color: orange"> {{names[0].tns_name}}</p>
              </b-card-text>
            </b-card>
          </b-col>
          <b-col lg="2">
          </b-col>
          <b-col lg="2">
            <b-card
              title= "Repeater Name"
              tag="article"
              style="max-width: 20rem; background-color: #343A40; color: white"
              class="mb-2"
            >
              <b-card-text>
                <b-link v-bind:href="'/repeaters/' + names[0].repeater_name" target='_blank'>
                  <p style="font-size: 150%; color: orange">
                      {{names[0].repeater_name}}
                  </p>
                </b-link>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
        <div class="mt-4">
          <div>
            <b-card-group>
              <b-card bg-variant="dark" title="Localization Plot">
              <b-alert v-if="links.localization === null" show variant="danger"> <h3> Header localization plot not available.</h3> This event is either a side-lobe event or a well-localized repeater. See catalog for more details.</b-alert>
              <a
                v-else
                :href="links.localization"
                target="_blank">
                <b-img
                  :src="links.localization"
                  fluid
                  alt="No image found">
                </b-img>
              </a>
            </b-card>
              <b-card title = "Localization, Exposure & Fluence Thresholds" bg-variant="dark" text-variant="warning">
                <b-card-text class="text-left">
                  <b-table dark
                           show-empty
                           fixed
                           :field="fields"
                           :items="loc"
                           :small=true
                           >
                  </b-table>
                </b-card-text>
              </b-card>
            </b-card-group>
          </div>

          <div>
            <b-card-group>
              <b-card title="Burst Properties" bg-variant="dark" text-variant="warning">
                <b-card-text class="text-left">
                  <b-table dark
                    show-empty
                    fixed
                    :field="fields"
                    :items="waterfall"
                    :small=true
                  >
                  </b-table>
                </b-card-text>
              </b-card>
              <b-card bg-variant="dark" title="Waterfall Plot">
              <a 
                :href="links.waterfall_hires"
                target="_blank">
                <b-img
                  :src="links.waterfall_hires"
                  fluid
                  alt="No image found">
                </b-img>
              </a>
            </b-card>
            </b-card-group>
          </div>
        </div>
      </b-container>
    </div>
    </div> 
  </div>
</template>

<script>
import { filterMixin } from "./mixins/filter_mixin.js";
export default {
  name: "event",
  mixins: [filterMixin],
  data() {
    return {
      links: {},
      source_name: "",
      fields: [],
      source: null,
      names: null,
      burst_properties: null,
      subburst_properties: null,
      loc: null,
      waterfall: null,
      exp: null,
      if_subburst: "true"
    };
  },
  mounted() {
    // var url = 'http://localhost:8081/source'
    var url = "https://catalog.chime-frb.ca/catalog";
    this.fetchSources(url);
    this.fetchLastUpdated("frbs");
  },
  computed: {},
  methods: {
    fetchSources(url) {
      return this.$http
        .post(url, {
          user_email: localStorage.user_email,
        })
        .then((response) => {
          if (response.body) {
            this.parseResponse(response.body);
          }
        });
    },
    parseResponse(sources) {
      const source_name = this.$route.params.id;
      console.log(source_name);
      for (let i = 0; i < sources.length; i++){
        if (sources[i].tns_name === source_name) {
          const s = sources[i];
          // initializing dictionaries
          this.names = {};
          this.burst_properties = {}
          this.subburst_properties = {}
          this.loc = {}
          this.waterfall = {}
          // setting names
          this.names['tns_name'] = s['tns_name'];
          if (!s['previous_name'] || s['previous_name'] === '') {
            s['previous_name'] = 'N/A';
          }
          this.names['previous_name'] = s['previous_name'];
          if (s['repeater_name'] === '') {
            s['repeater_name'] = 'N/A';
          }
          this.names['repeater_name'] = s['repeater_name'];


          this.loc["ra [degrees]"] = s['ra']+ '\xB1' +s['ra_err'];
          this.loc["dec [degrees]"] = s['dec']+ '\xB1' +s['dec_err'];
          this.loc["gl [degrees]"] = s['gl'];
          this.loc["gb [degrees]"] = s['gb'];
          this.loc["dm_exc_ne2001 [pc cm−3]"] = s['dm_exc_ne2001'];
          this.loc["dm_exc_ymw16 [pc cm−3]"] = s['dm_exc_ymw16'];

          if (s['exp_low'] && s['exp_low_err']) {
            this.loc["exp_low [hour]"] = s['exp_low']+ '\xB1' +s['exp_low_err'];
          }
          if (s['exp_up'] && s['exp_up_err']) {
            this.loc["exp_up [hour]"] = s['exp_up']+ '\xB1' +s['exp_up_err'];
          }
          this.loc["low_ft_68 [Jy ms]"] = s['low_ft_68'];
          this.loc["low_ft_95 [Jy ms]"] = s['low_ft_95'];
          this.loc["up_ft_68 [Jy ms]"] = s['up_ft_68'];
          this.loc["up_ft_95 [Jy ms]"] = s['up_ft_95'];

          this.waterfall["bonsai_snr"] = s['bonsai_snr'];
          this.waterfall["bonsai_dm [pc cm−3]"] = s['bonsai_dm'];
          this.waterfall["snr_fitb"] = s['snr_fitb'];
          this.waterfall["dm_fitb [pc cm−3]"] = s['dm_fitb']+ '\xB1' +s['dm_fitb_err'];
          this.waterfall["flux [Jy]"] = s['flux']+ '\xB1' +s['flux_err'];
          this.waterfall["fluence [Jy ms]"] = s['fluence']+ '\xB1' +s['fluence_err'];
          this.waterfall["bc_width [s]"] = s['bc_width'];
          this.waterfall["scat_time [s]"] = s['scat_time'];
          this.waterfall["mjd_400 [MJD]"] =s['mjd_400'] + '\xB1' + s['mjd_400_err'];
          this.waterfall["mjd_inf [MJD]"] =s['mjd_inf'] + '\xB1' + s['mjd_inf_err'];
          this.waterfall["width_fitb [s]"] =s['width_fitb'] + '\xB1' +s['width_fitb_err'];
          this.waterfall['sp_idx'] = s['sp_idx'] + '\xB1' + s['sp_idx_err'];
          this.waterfall['sp_run'] = s['sp_run'] + '\xB1' + s['sp_run_err'];
          this.waterfall['peak_freq [MHz]'] = s['peak_freq'];
          this.waterfall['high_freq [MHz]'] = s['high_freq'];
          this.waterfall['low_freq [MHz]'] = s['low_freq'];
          this.waterfall["chi_sq"] = s['chi_sq'];
          this.waterfall["dof"] = s["dof"];
          this.waterfall["flag_frac"] = s["flag_frac"];
          this.if_subburst = 'false';


          if (this.waterfall["scat_time [s]"][0] !== '<') {
            this.waterfall["scat_time [s]"] = s['scat_time']+ '\xB1' +s['scat_time_err'];
          }
          var frequencies = null;
          var subburst_length = null;
          frequencies = s['peak_freq'];
          console.log(frequencies);
          subburst_length = frequencies.length;
          if (subburst_length > 1) {
            // setting sub-burst properties
            for (let i = 0; i < subburst_length; i++) {
              this.waterfall['peak_freq [MHz]'] = s['peak_freq'];
              this.waterfall['high_freq [MHz]'] = s['high_freq'];
              this.waterfall['low_freq [MHz]'] = s['low_freq'];
            }
          }
        }
      }
      // Putting all dictionaries in arrays to be read by <b-table> items above
      this.names = [this.names]

      this.fields = [{key: 'parameter', label:'', class: "text-right"}, {key: 'value', label:'', class: "text-left"}]
      let final_vals = []
      for (let i = 0; i < Object.keys(this.loc).length; i++) {
        let key = Object.keys(this.loc)[i]
        let item = {'parameter': key, 'value':this.loc[key]}
        final_vals.push(item)
      }
      this.loc = final_vals

      final_vals = []
      for (let i = 0; i < Object.keys(this.waterfall).length; i++) {
        let key = Object.keys(this.waterfall)[i]
        let item = {'parameter': key, 'value':this.waterfall[key]}
        final_vals.push(item)
      }
      this.waterfall = final_vals

      
      this.source_name = this.names['tns_name'] + "_localization_contour.pkl";
      var base_link =
          "https://storage.googleapis.com/chimefrb-dev.appspot.com/";
      let name = this.names[0]['repeater_name']
      const missing_loc = ['FRB20180916B', 'FRB20181017A', 'FRB20181030B', 'FRB20121102A','FRB20190116B', 'FRB20190213A']
      const missing_tns = ['FRB20190210D', 'FRB20190125B', 'FRB20190202B']
      if (name === "N/A") {
        name = this.names[0]['tns_name']
      }
      this.links["localization"] = base_link + name + "/localization.png";
      if (missing_loc.includes(name) || missing_tns.includes(this.names[0]['tns_name'])) {
        this.links["localization"] = null;
      }
      this.links["waterfall_hires"] = base_link + this.names[0]['tns_name'] + "/waterfall_hires.png";
    },
    editSubBurst(key, s){
      var name_key = key;
      if (key == 'mjd_400') {
        name_key = 'mjd_400 [MJD]'
      }
      if (key == 'mjd_inf') {
        name_key = 'mjd_inf [MJD]'
      }
      if (key == 'width_fitb') {
        name_key = 'width_fitb [s]'
      }
      this.waterfall[name_key] = '['
      for (let i = 0; i < s[key].length; i++) {
        this.waterfall[name_key] = this.waterfall[name_key] + s[key][i] + '\xB1' + s[key + '_err'][i]
        if (i < s[key].length-1) {
          this.waterfall[name_key] = this.waterfall[name_key] + ', '
        }
      }
      this.waterfall[name_key] = this.waterfall[name_key] + ']'
    },
  },
};
</script>
<style>
.zoom {
  transition: transform 0s;
  /* Animation */
  width: 50px;
  height: 50px;
  margin: 0 auto;
}

.zoom:hover {
  transform: scale(5);
}
 .tab-title-class {
   color: #FFA500 !important;
 }
</style>
